import { Regex } from './Regex'

/**
 */
const FULL_WIDTH_KATAKANA_PATTERN = /^[ァ-ンヴー]*$/

/**
 */
export const FullWidthKatakana = Regex(FULL_WIDTH_KATAKANA_PATTERN)
